import { IconButton, Tooltip } from '@material-ui/core';
import { AgentCommissionIcon, CalendarDayIcon } from '../../../icons';

export const TicketSellingRangeToggleButton = ({
    showTicketSellingRanges,
    setShowTicketSellingRanges
}) => (
    <Tooltip
        title={
            showTicketSellingRanges
                ? 'Disable ticket selling range filtering'
                : 'Enable ticket selling range filtering'
        }
        placement="top"
    >
        <IconButton onClick={() => setShowTicketSellingRanges(!showTicketSellingRanges)}>
            <CalendarDayIcon
                style={{ fontSize: '1rem', opacity: showTicketSellingRanges ? 1 : 0.3 }}
            />
        </IconButton>
    </Tooltip>
);

const ActivityActionButtons = ({
    showCommission,
    setShowCommission,
    showTicketSellingRanges,
    setShowTicketSellingRanges
}) => {
    return (
        <>
            <TicketSellingRangeToggleButton
                showTicketSellingRanges={showTicketSellingRanges}
                setShowTicketSellingRanges={setShowTicketSellingRanges}
            />
            <Tooltip title="Commission">
                <IconButton
                    style={{ fontSize: '1rem', opacity: showCommission ? 1 : 0.3 }}
                    onClick={() => setShowCommission(!showCommission)}
                >
                    <AgentCommissionIcon />
                </IconButton>
            </Tooltip>
        </>
    );
};

export default ActivityActionButtons;
